import { ScreenSizeEnum, useScreenSize } from "shared/use-screen-size";
import Box from "@mui/material/Box";
import { IconButton, Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

interface Props {
  from: string;
  here?: string | null;
  setViewState?: (state: number) => void;
  viewState?: number;
}

export const FavListBreadcrumbNav = (props: Props) => {
  const { from, here } = props;
  const { screenSize } = useScreenSize();

  return (
    <Box displayPrint="none">
      {screenSize === ScreenSizeEnum.Mobile ? (
        <Box sx={{ display: "flex", pt: "24px", pl: "24px" }}>
          <Typography variant="h5" color="primary.main" sx={{ pl: 1 }} onClick={() => props.setViewState?.(1)}>
            {from}
          </Typography>
          {props.viewState === 2 && (
            <>
              {" "}
              <IconButton sx={{ pt: 0 }}>
                <KeyboardArrowRightIcon />
              </IconButton>
              <Typography variant="h5" color={"secondary.main"}>
                {here}
              </Typography>
            </>
          )}
        </Box>
      ) : (
        <Box sx={{ display: "flex", pt: "24px", pl: "24px" }}>
          <Typography variant="h5" color={"primary.main"} sx={{ cursor: props.viewState === 2 ? "pointer" : "default" }} onClick={() => props.setViewState?.(1)}>
            {from}
          </Typography>
          {props.viewState === 2 && (
            <>
              <IconButton sx={{ p: 0 }}>
                <KeyboardArrowRightIcon />
              </IconButton>
              <Typography variant="h5" color={"secondary.main"}>
                {here}
              </Typography>
            </>
          )}
        </Box>
      )}
    </Box>
  );
};
